import type { RouteLocationRaw } from 'vue-router';

import type { AuthContext } from '@shared/context/authContext';
import {
  getUserRoleCatalogRolesByRouteGroup,
  loadUserRoleCatalog
} from '@shared/reference-catalogs/useUserRoleCatalog';

const hasRoleCatalogGroup = (
  auth: AuthContext,
  group: Parameters<typeof getUserRoleCatalogRolesByRouteGroup>[0]
) => {
  const roles = getUserRoleCatalogRolesByRouteGroup(group);
  return roles.length > 0 && auth.hasAnyRole(roles);
};

export const resolveAuthedHomeRoute = (auth: AuthContext): RouteLocationRaw => {
  if (!auth.isAuthenticated) {
    return { name: 'login' };
  }

  if (hasRoleCatalogGroup(auth, 'user-admin-home')) {
    return { name: 'users-list' };
  }

  if (hasRoleCatalogGroup(auth, 'operator-home')) {
    return { name: 'operator-stages' };
  }

  if (hasRoleCatalogGroup(auth, 'quality-workspace')) {
    return { name: 'injection-molding-quality' };
  }

  if (hasRoleCatalogGroup(auth, 'inventory-write')) {
    return { name: 'injection-molding-warehouse' };
  }

  if (hasRoleCatalogGroup(auth, 'task-workspace')) {
    return { name: 'workflows-next-tasks' };
  }

  if (hasRoleCatalogGroup(auth, 'workplace-shift-management')) {
    return { name: 'assembly-shift-management' };
  }

  return { name: 'dashboard' };
};

export const resolveAuthedHomeRouteWithCatalog = async (auth: AuthContext): Promise<RouteLocationRaw> => {
  if (auth.isAuthenticated) {
    await loadUserRoleCatalog(auth.authHeaders);
  }

  return resolveAuthedHomeRoute(auth);
};
